module.exports = __webpack_public_path__ + "static/media/download.e1627627.svg";


//////////////////
// WEBPACK FOOTER
// ./src/res/img/download.svg
// module id = 353
// module chunks = 0